<script>
import LoginForm from './my-favorites-modal-login-form.vue';
import PreLoginForm from './my-favorites-prelogin-form.vue';
import RegisterForm from './my-favorites-modal-register-form.vue'; 

export default {
    data: function() {
        return {
            fields: {},
            
            forms: {
                login: false,
                prelogin: true,
                registration: false
            }
        }
    },

    components: {
        'my-favorites-prelogin-form': PreLoginForm,
        'my-favorites-modal-login-form': LoginForm,
        'my-favorites-modal-register-form': RegisterForm
    },

    methods: {
        show(key) {
            for(const form in this.forms) {
                this.forms[form] = false;
            }

            this.forms[key] = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/components/forms/my-favorites-modal.vue